const fontStyles = {
	regular: `AkkuratLLWeb-Regular`,
	bold: `AkkuratLLWeb-Bold`,
	black: `AkkuratLLWeb-Black`,
	mono: `AkkuratMonoLLWeb-Regular`,
	monoBold: `AkkuratMonoLLWeb-Bold`,
	compressedBlack: `GT-America-Compressed-Black`,
	compressedMedium: `GT-America-Compressed-Medium`,
}

export default fontStyles
